import semiconductor from '../img/Domains/半導體行業.jpg';
import traditionalmanufacturing from '../img/Domains/傳統製造行業.jpg';
import electricalproduct from '../img/Domains/電子產品業.jpg';
import care from '../img/Domains/照服行業.jpg';
import mes from '../img/Domains/物業管理行業.jpg';
import exhibition from '../img/Domains/會展管理行業.jpg';
import onlineshoppping from '../img/Domains/線上購物.jpg';
import advertise from '../img/Domains/廣告業行業.jpg';
import normal from '../img/Domains/一般行業.PNG';

const DomainGroups = [
    { Src: semiconductor, Alt: "Semiconductor",Caption:"半導體行業" },
    { Src: traditionalmanufacturing, Alt: "Traditional Manufacturing",Caption:"傳統製造行業" },
    { Src: electricalproduct, Alt: "Electrical Product",Caption:"電子產品業" },
    { Src: care, Alt: "Care",Caption:"照服行業" },
    { Src: mes, Alt: "MES",Caption:"物業管理行業" },
    { Src: exhibition, Alt: "Exhbition",Caption:"會展管理行業" },
    { Src: onlineshoppping, Alt: "Online Shopping",Caption:"線上購物" },
    { Src: advertise, Alt: "Advertise",Caption:"廣告業行業" },
    { Src: normal, Alt: "Normal",Caption:"一般行業"}
];

export default DomainGroups;